<template>
    <section id="cta" class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="relative overflow-hidden bg-foreground rounded-3xl p-8 md:p-16">
                <div class="max-w-3xl mx-auto text-center relative z-10">
                    <h2 class="text-3xl sm:text-4xl mb-6 text-white">
                        {{ $t('cta.title') }}
                    </h2>
                    <p class="text-xl text-white/90 mb-8">
                        {{ $t('cta.subtitle') }}
                    </p>

                    <div class="flex flex-wrap justify-center gap-4 mb-8">
                        <a href="#contact" class="bg-white text-foreground px-8 py-4 rounded-lg hover:bg-gray-50 transition-all flex items-center gap-2 group uppercase text-sm tracking-wide font-medium">
                            {{ $t('cta.getStarted') }}
                            <ArrowRightIcon class="size-5 group-hover:translate-x-1 transition-transform" />
                        </a>
                        <a href="#contact" class="border-2 border-white/30 bg-white/10 backdrop-blur text-white px-8 py-4 rounded-lg hover:bg-white/20 transition-all uppercase text-sm tracking-wide font-medium">
                            {{ $t('cta.contactSales') }}
                        </a>
                    </div>

                    <div class="flex flex-wrap justify-center gap-6 text-sm text-white/90">
                        <div class="flex items-center gap-2">
                            <CheckIcon class="size-4 text-white" />
                            <span>{{ $t('cta.benefit1') }}</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <CheckIcon class="size-4 text-white" />
                            <span>{{ $t('cta.benefit2') }}</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <CheckIcon class="size-4 text-white" />
                            <span>{{ $t('cta.benefit3') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { CheckIcon, ArrowRightIcon } from '@heroicons/vue/24/outline';

export default defineComponent({
    name: 'CtaSection',
    components: {
        CheckIcon,
        ArrowRightIcon
    }
});
</script>
